import { mapGetters } from 'vuex';
import mvtAttribute from '@/common/components/mvtattribute/mvt-attribute.vue';

export default {
    name: 'propertyDesc',
    inject: ['$eventBus'],
    components: {
        mvtAttribute,
    },
    data() {
        return {
            descriptionExpanded: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'favoriteListings', 'getSplit']),
        ...mapGetters('dpp', ['dpp', 'getAttributes']),
        descriptionExpandable() {
            return this.dpp.description.length > 700;
        },
        isFavorite() {
            return this.favoriteListings.indexOf(this.dpp.propertyId) !== -1;
        },
        getCityPathForFilters() {
            if (!this.glb.geo.cityPath) {
                return '';
            }
            return this.glb.geo.cityPath.replace('homes-for-sale/', '');
        },
        getAllPills() {
            let defaultlist = [];

            let filtered = [
                'staycation ready',
                'wide open spaces',
                'perfect for kids',
                'garage',
                'green thumb required',
                'backyard',
                'perfect for pets',
                'perfect for hosting',
                'living room',
                'perfect for block parties',
                'room with a view',
                'view',
                'lower effort',
                'charm',
                'investment opportunity',
                'laundry area',
                'dining room',
                'investment property',
                '2-car garage',
                'for the young professional',
                'work from home',
            ];
            if (this.getAttributes && this.getAttributes.length > 0) {
                let attributes = this.getAttributes.filter((e) => {
                    return !filtered.includes(e.displayName.toLowerCase());
                });
                defaultlist = defaultlist.concat(attributes);
            }
            return defaultlist;
        },
    },
    methods: {
        toggleDescription() {
            this.descriptionExpanded = !this.descriptionExpanded;
        },
        favoriteAction() {
            this.$eventBus.$emit('property-save-favorite', this.$options.name);
        },
    },
};
